<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <img src="./assets/images/Proctoring-Management_Icon.png" alt="" />
          <!-- <i class="material-icons cusIconSize">&#xE7FD;</i> -->
          <span>Search Proctor</span>
        </p>
      </div>

      <!-- Add Edit form -->
      <div class="admManageExamBreadcumTitle">
        <p class="admManageExamBreadcumCls">
          <span>
            <a class="searchFormLink" [showUnSavedChangesAlert]="{ form: form, redirect: redirectUrl}">Search Proctor</a> >
            <span class="addEditFormLink"> {{pageConfig.title}}</span>
          </span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span> {{pageConfig.title}}</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="example-form" [formGroup]="form">
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="First Name" formControlName="firstName" maxlength="100">
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Last Name" formControlName="lastName" maxlength="100">
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Email" formControlName="userEmail" maxlength="100">
                </md-form-field>
                <p class="validate" *ngIf="form.controls.userEmail.value && form.controls.userEmail.invalid">Incorrect Email Format</p>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Kerberos User Name" formControlName="rhId" maxlength="100">
                </md-form-field>
                <p requiredField *ngIf="form.controls.rhId.touched && form.controls.rhId.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Phone" formControlName="contactNumber" maxlength="20">
                </md-form-field>
                <p validatePhoneNumber *ngIf="form.controls.contactNumber.touched && form.controls.contactNumber.errors && form.controls.contactNumber.errors.pattern"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Office" mdInput formControlName="officeId" [mdAutocomplete]="office">
                  <md-autocomplete #office="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of officeFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf="form.controls.officeId.touched && form.controls.officeId.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-select placeholder="Select Group" formControlName="groupId" multiple>
                  <md-option *ngFor="let option of groupOptions" [value]="option">
                    {{ option.groupCode }}
                  </md-option>
                </md-select>
                <p requiredField *ngIf="form.controls.groupId.touched && form.controls.groupId.invalid"></p>
              </div>

            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Maximum # of Sessions" formControlName="maxSession" maxlength="4">
                </md-form-field>
                <p requiredField *ngIf="form.controls.maxSession.touched && form.controls.maxSession.errors && form.controls.maxSession.errors.required"></p>
                <p validateOnlyNumeric *ngIf="form.controls.maxSession.touched && form.controls.maxSession.errors && form.controls.maxSession.errors.pattern"></p>
              </div>
            </div>

            <div class="col s12 m4 l4" *ngIf="showField">
              <div class="errorZoneSec">
                <md-select placeholder="Proctor Lead" formControlName="islead">
                  <md-option *ngFor="let option of proctorLeadOptions" [value]="option">
                    {{ option.text }}
                  </md-option>
                </md-select>
                <p requiredField *ngIf="form.controls.islead.touched && form.controls.islead.invalid"></p>
              </div>
            </div>
          </form>
        </md-card-content>
        <md-card-actions>
          <div class="button-row">
            <button [disabled]="form.invalid || pageConfig.isSaveDisable || (form.controls.officeId.value && !form.controls.officeId.value.id)"
              md-raised-button class="glbAdminBtnCls1" (click)="onSave()">
              SAVE</button>
            <button [disabled]="pageConfig.isEditDisable" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">
              EDIT</button>
            <button [disabled]="pageConfig.isActiveDisable" md-raised-button class="glbAdminBtnCls1" (click)="onUpdateStatus(0)">ACTIVATE</button>
            <button [disabled]="pageConfig.isRetireDisable" md-raised-button class="glbAdminBtnCls1" (click)="onUpdateStatus(1)">RETIRE</button>
          </div>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</section>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-update-proctor-team-lead/adm-update-proctor-team-lead.component.html